import { createStore, type Store, type StoreActionApi } from 'react-sweet-state';

import type { State } from './State';

export const store: Store<
	State,
	{
		openModal: ({
			messageId,
			conversationId,
		}: {
			messageId: string;
			conversationId: string;
		}) => ({ setState }: StoreActionApi<State>) => Promise<void>;
		closeModal: () => ({ setState }: StoreActionApi<State>) => void;
	}
> = createStore({
	name: 'agentDebugModal',
	initialState: {
		isOpen: false,
		data: null,
	} as State,
	actions: {
		openModal:
			({
				messageId,
				conversationId,
			}: {
				messageId: string;
				conversationId: string;
			}): (({ setState }: StoreActionApi<State>) => Promise<void>) =>
			async ({ setState }) => {
				setState({
					isOpen: true,
					data: {
						messageId,
						conversationId,
					},
				});
			},

		closeModal:
			(): (({ setState }: StoreActionApi<State>) => void) =>
			({ setState }) => {
				setState({
					isOpen: false,
					data: null,
				});
			},
	},
});
